// Form values rehydrated from the URL reach us as scalars (`FormFieldType.Radio` - see from_query_values) or as
// numbers (`FormFieldType.MultiCheckbox` runs parseInt), while every `filterOptions` value is a string.
// SRV-583: reading such a value as an array without normalizing it throws and kills the interaction it runs in.
export type IFilterOptionsValue = string | number | (string | number)[] | null | undefined;

export const toFilterOptionValues = (values: IFilterOptionsValue): string[] => {
    if (values == null || values === "") {
        return [];
    }
    return (Array.isArray(values) ? values : [values]).map(String);
};
// Form values rehydrated from the URL reach us as scalars (`FormFieldType.Radio` - see from_query_values) or as
// numbers (`FormFieldType.MultiCheckbox` runs parseInt), while every `filterOptions` value is a string.
// SRV-583: reading such a value as an array without normalizing it throws and kills the interaction it runs in.
export type IFilterOptionsValue = string | number | (string | number)[] | null | undefined;

export const toFilterOptionValues = (values: IFilterOptionsValue): string[] => {
    if (values == null || values === "") {
        return [];
    }
    return (Array.isArray(values) ? values : [values]).map(String);
};
